export default __webpack_public_path__ + "static/media/step-4-fr.267044a1.svg";